import { lazy } from "react"
import {
  BIRDS_GROUPS_EVENT_VIEW,
  BIRD_GROUP_EVENT_LIST_VIEW,
  NEW_BIRDS_GROUPS_EVENTS_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllBirdsGroupsEventsView = lazy(
  () =>
    import(
      "@/features/events/birds-groups-events/views/all-birds-groups-events-view/all-birds-groups-events-view.tsx"
    ),
)

const BirdsGroupsEventView = lazy(
  () =>
    import(
      "@/features/events/birds-groups-events/views/birds-groups-event-view/birds-groups-event-view.tsx"
    ),
)

const NewBirdsGroupsEventsView = lazy(
  () =>
    import(
      "@/features/events/birds-groups-events/views/new-birds-groups-events-view/new-birds-groups-events-view.tsx"
    ),
)

export const birdsGroupsEventsRoutes = [
  {
    path: BIRD_GROUP_EVENT_LIST_VIEW,
    element: <AllBirdsGroupsEventsView />,
  },
  {
    path: NEW_BIRDS_GROUPS_EVENTS_VIEW,
    element: <NewBirdsGroupsEventsView />,
  },
  {
    path: BIRDS_GROUPS_EVENT_VIEW,
    element: <BirdsGroupsEventView />,
  },
]
const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: birdsGroupsEventsRoutes,
  },
]

export const MOBILE_BIRDS_GROUPS_EVENTS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: birdsGroupsEventsRoutes,
  },
]

export const getBirdsGroupsEventsRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_BIRDS_GROUPS_EVENTS_ROUTES
}
